import { cn } from "../../lib/cn";

/** The BaraPOS mark, a placeholder until the real logo lands. This is the one place to swap it:
 * replace the <svg> below (keep `aria-hidden`), and every sign-in screen, system page and the
 * admin rail pick it up. */
export function BrandMark({ size = 40, wordmark = true, onDark, sub, className }: { size?: number; wordmark?: boolean; onDark?: boolean; sub?: string; className?: string }) {
  return (
    <span className={cn("inline-flex items-center gap-3", className)}>
      <span
        aria-hidden="true"
        className="relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-[30%] bg-[linear-gradient(135deg,var(--hero-from),var(--hero-to))] text-white shadow-[0_10px_28px_-10px_var(--hero-glow)]"
        style={{ width: size, height: size }}
      >
        <span className="absolute inset-x-0 top-0 h-1/2 bg-white/12" />
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round" className="relative" style={{ width: size * 0.56, height: size * 0.56 }}>
          <path d="M8.5 4.5h4.75a3.5 3.5 0 0 1 0 7H8.5z" />
          <path d="M8.5 11.5h5.75a4 4 0 0 1 0 8H8.5z" />
          <path d="M3.5 8h2.25M3.5 12h1.5M3.5 16h2.25" opacity={0.7} />
        </svg>
      </span>
      {wordmark && (
        <span className="flex flex-col leading-none">
          <span className={cn("font-extrabold tracking-[-0.02em]", size >= 44 ? "text-2xl" : size >= 36 ? "text-xl" : "text-lg", onDark ? "text-white" : "text-neutral-900")}>
            BaraPOS
          </span>
          {sub && <span className={cn("mt-1 text-2xs font-semibold uppercase tracking-[0.16em]", onDark ? "text-white/60" : "text-neutral-500")}>{sub}</span>}
        </span>
      )}
    </span>
  );
}
